import type { NodeV2 } from '@vedalib/editor'
import type { EditorElement } from '@vedalib/editor/lib/elements'
import React, { useMemo, useState } from 'react'

import { NODES } from 'components/Editor/NodeV2/Picker/complexNodes'
import Padding from 'components/Editor/Toolbar/Padding'
import { LayoutScroll } from 'components/LayoutPage'
import Search from 'components/uiKit/Search'
import type { Block, MapType } from 'services/Store/Project/types'

import TileNode from '../TileNode'
import * as s from './TabFrame.module.scss'

interface ITabFrameProps {
  block: Block
  parent: NodeV2
  onAdd: (
    node: NodeV2,
    data?: { nodes?: MapType<NodeV2>; elements?: MapType<EditorElement> },
  ) => void
}

const TabFrame: React.FC<ITabFrameProps> = ({ onAdd, block, parent }) => {
  const [search, setSearch] = useState<string>()

  const items = useMemo(
    () =>
      NODES.filter(
        ({ root }) => !search || root.label?.toLowerCase().includes(search.toLowerCase()),
      ),
    [search],
  )

  return (
    <div className={s.root}>
      <Padding bottom sides top>
        <Search name='elements' onChange={setSearch} value={search} width='100%' />
      </Padding>
      <LayoutScroll sizeAutoCapable>
        <Padding bottom gap sides>
          <div className={s.items}>
            {items.map(({ root, elements, nodes, image }) => (
              <TileNode
                block={block}
                elements={elements}
                image={image}
                item={root}
                key={root.id}
                nodes={nodes}
                onAdd={onAdd}
                parent={parent}
              />
            ))}
          </div>
        </Padding>
      </LayoutScroll>
    </div>
  )
}

export default TabFrame
